import React from 'react'
import {
  UpdateStatusMenu,
  UpdateStatusManager,
  defaultStatusRegistry,
  Status,
  Substatus
} from '../vulnerability-status'
import { Vulnerability } from './status-action'
import { Role } from '@contrast-security-inc/base-types'
import { VulnerabilityStatus } from '../../graphql/schema/shared'

interface Props {
  readonly organizationID: string
  readonly filters?: {
    readonly filterText: string
    readonly quickFilter: string
    readonly aggregations: Record<string, string[]>
  }
  readonly additionalFilters?: { readonly [key: string]: any }
  readonly updateStatus: (values: {
    readonly status: Status
    readonly substatus?: Substatus
    readonly reasoning?: string
  }) => Promise<any>
  readonly applicationRole: Role
  readonly isStatusApprovalEnabled: boolean
  readonly menuPlacement: 'top' | 'bottom'
  readonly vulnerabilities: Vulnerability[]
}

export function UpdateStatusAction({
  organizationID,
  filters,
  additionalFilters,
  updateStatus,
  applicationRole,
  isStatusApprovalEnabled,
  menuPlacement,
  vulnerabilities
}: Props) {
  return (
    <UpdateStatusManager
      organizationID={organizationID}
      traceIDs={vulnerabilities.map((v) => v.id)}
      filters={filters}
      additionalFilters={additionalFilters}
      updateStatus={updateStatus}
      isStatusApprovalEnabled={isStatusApprovalEnabled}
      currentStatus={
        vulnerabilities.length === 1
          ? Status.fromName(vulnerabilities[0].status as VulnerabilityStatus)
          : undefined
      }
    >
      {({ onSelectStatus }) => {
        return (
          <UpdateStatusMenu
            role={applicationRole}
            onSelectStatus={onSelectStatus}
            statusRegistry={defaultStatusRegistry}
            menuPlacement={menuPlacement}
            vulnerabilities={vulnerabilities}
          />
        )
      }}
    </UpdateStatusManager>
  )
}
